

import DATA from "../data/_entity.json";

const Why = () => {
   return (
      <>

         <h2>&nbsp;What's Different</h2>
         {Object.entries(DATA.entity.poi).length > 1 ? (
            Object.entries(DATA.entity.poi).map((key) => {
               return (

                  <div className="framer" key={key[0]}>
                     <div className="row"><h3>{key[0]}</h3></div>
                     <div className="row">
                        <div className="col-sm-6 col-md-6">
                           {key[1][1].map((l) => {
                              return (
                                 <span key={l}>{l} </span>
                              )
                           })}
                           <div className="col-sm-12 col-md-12">
                              <img src={key[1][0]} alt="" width="100%"></img>
                           </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                           <ul className="ul1">
                              {key[1][2].split(/(?<=[.?!])\s+/).map((l) => {
                                 return (
                                    <li key={l}>{l}</li>
                                 )
                              })}
                           </ul>
                        </div>
                     </div>

                  </div>

               )
            })) : (null)}

      </>
   )
}

export default Why;




